'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
/**
 * Encapsulates the result of a layout grouping selection.
 *
 * @class
 * @extends DesignData/models/ImmutableModel
 */

export default class ValidatedLayoutGroup extends ImmutableModel {
  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    return super(props);
  }

}
ValidatedLayoutGroup.DEFAULT_FIELDS = {
  isValid: false,
  errorType: null,
  errorMessage: null,

  /** Matrix of all widgets (selected or not) that are affected by grouping */
  groupingMatrix: null
};